import { render, staticRenderFns } from "./BErrorPageTemplate.vue?vue&type=template&id=2bd5019c&scoped=true"
import script from "./BErrorPageTemplate.vue?vue&type=script&lang=js"
export * from "./BErrorPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./BErrorPageTemplate.vue?vue&type=style&index=0&id=2bd5019c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5019c",
  null
  
)

export default component.exports